import { render, staticRenderFns } from "./QrOrderAlternativePay.vue?vue&type=template&id=2cee07d2&scoped=true&"
import script from "./QrOrderAlternativePay.vue?vue&type=script&lang=js&"
export * from "./QrOrderAlternativePay.vue?vue&type=script&lang=js&"
import style0 from "./QrOrderAlternativePay.vue?vue&type=style&index=0&id=2cee07d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cee07d2",
  null
  
)

export default component.exports